import useCompletedModeMapMarkers from './useCompletedModeMapMarkers';

export default useCompletedModeMapMarkers;
